import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';

export enum TrackAuctionRegistrationSubmittedType {
    Auto = 'Auto',
    Bid = 'Bid',
    User = 'User',
}

type TrackAuctionRegistrationSubmittedPayload = TrackingPayload & {
    registrationType: TrackAuctionRegistrationSubmittedType;
    /**
     * True when the bidder checked the Terms of Sale box. False on the control Review page,
     * where acceptance is the Submit click. Omitted when registration did not go through Review.
     */
    termsAcceptedExplicitly?: boolean;
};

export const trackAuctionRegistrationSubmittedAnalytics = (payload: TrackAuctionRegistrationSubmittedPayload) => {
    track(TrackingEvents.Registration.AuctionRegistrationSubmitted, payload);
};
